
import { Box, Typography, Checkbox } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CustomButton from "../controls/CustomButton";
import useTitanApp from "../../hooks/useTitanApp";

export default function StartOrbitSendModal({ handleContinue }) {

    const { appState } = useTitanApp();
    const { darkMode } = appState || {};
    const checkIconColor = darkMode === true ? "white" : "black";
    const options = [
        {
            title: "Fully managed service",
            description:
                "The partner will fully manage the end to end journey of each service",
        },
        {
            title: "Call recording",
            description:
                "Each call is recorded and transcribed allowing you to monitor what was said to your patients",
        },
        {
            title: "Real Time",
            description:
                "See your services being completed in real time without any delay",
        },
    ];
    return (
        <>
            <div className="nms-to-orbit-content">
                <Typography className="nms-to-orbit-description">
                    TITAN ORBIT allows you to outsource all of your
                    services to our selected partners who will complete
                    the service on your behalf.
                </Typography>
                {options?.map(({ title, description }) => (
                    <Box>
                        <div className="nms-to-orbit-option">
                            <div className="nms-to-orbit-option-header">
                                <Typography
                                    variant="nms-title-orbit"
                                    fontWeight="bold"
                                >
                                    {title}
                                </Typography>
                                <Checkbox
                                    checkedIcon={
                                        <CheckCircleIcon
                                            sx={{ color: checkIconColor }}
                                        />
                                    }
                                    checked={true}
                                />
                            </div>
                            <div className="nms-text-orbit-wrapper">
                                <Typography className="nms-to-orbit-description">
                                    {description}{" "}
                                </Typography>
                            </div>
                        </div>
                    </Box>
                ))}
            </div>
            <div className="send-to-orbit-footer">
                <CustomButton
                    label="Start "
                    action={handleContinue}
                    icon={<NavigateNextIcon />}
                />
            </div>
        </>
    )
}
